import dayjs from 'dayjs';
import { TIME_24_HOUR_FORMAT } from 'constants/dateTime';

export function removeTempIdsFromHours(hours) {
  return hours.map(({ tempId, uuid, ...hour }) => hour);
}

export const compareState = (initialState, currentState, isHourState = false) => {
  if (isHourState) {
    return (
      JSON.stringify(removeTempIdsFromHours(initialState)) !==
      JSON.stringify(removeTempIdsFromHours(currentState))
    );
  }
  return JSON.stringify(initialState) !== JSON.stringify(currentState);
};

export const checkIfStatesTouched = ({
  initialStates,
  schedules,
  specialHours,
  deliveryHours,
  selectedIntegrations,
  selectedLinkedMerchants,
  menuEnabled,
}) => {
  const isSchedulesTouched = compareState(initialStates.schedules, schedules, true);
  const isSpecialHoursTouched = compareState(initialStates.specialHours, specialHours, true);
  const isDeliveryHoursTouched = compareState(initialStates.deliveryHours, deliveryHours, true);
  const isSelectedIntegrationsTouched = compareState(
    initialStates.selectedIntegrations,
    selectedIntegrations,
  );
  const isSelectedLinkedMerchantsTouched = compareState(
    initialStates.selectedLinkedMerchants,
    selectedLinkedMerchants,
  );
  const isMenuEnabledTouched = compareState(initialStates.menuEnabled, menuEnabled);

  return (
    isSchedulesTouched ||
    isSpecialHoursTouched ||
    isDeliveryHoursTouched ||
    isSelectedIntegrationsTouched ||
    isSelectedLinkedMerchantsTouched ||
    isMenuEnabledTouched
  );
};

export const getProcessedSchedules = hours => {
  if (!hours?.length) return [];

  return Object.values(
    hours.reduce(
      (schedulesByDay, schedule) => ({
        ...schedulesByDay,
        [schedule.dayIndex]: [...(schedulesByDay[schedule.dayIndex] || []), schedule],
      }),
      {},
    ),
  ).flatMap(daySchedules => {
    const sortedDaySchedules = [...daySchedules].sort((a, b) => {
      const start1 = dayjs(a.startTime, TIME_24_HOUR_FORMAT);
      const start2 = dayjs(b.startTime, TIME_24_HOUR_FORMAT);
      return start1.diff(start2);
    });
    return sortedDaySchedules.map((schedule, index) => ({
      ...schedule,
      isPeriod: index > 0,
    }));
  });
};

export const getIntegrations = menu => {
  const merchantIntegrations = menu?.integrations?.filter(
    int => Number(int.merchantId) === menu?.merchantId,
  );
  return merchantIntegrations?.map(int => int.integrationName) || [];
};
